import { Dialog, DialogContent, IconButton, styled, type DialogProps } from "~/common/mui";
import { forwardRef } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export type OverlayProps = DialogProps;

const OverlayRoot = forwardRef<HTMLDivElement, OverlayProps>(({ children, PaperProps, ...props }, ref) => (
  <Dialog
    ref={ref}
    {...props}
    fullScreen
    PaperProps={{
      sx: {
        maxHeight: "100%",
        borderRadius: 0,
      },
    }}
  >
    {children}
  </Dialog>
));

OverlayRoot.displayName = "Overlay";

export const Overlay = OverlayRoot;
export const OverlayContent = DialogContent;

export const OverlayHeader = styled((props: JSX.IntrinsicElements["div"] & { onClose?: () => void }) => {
  const { onClose, children, ...rest } = props;
  return (
    <div {...rest}>
      <div>{children}</div>
      {onClose && (
        <IconButton size="large" onClick={onClose}>
          <CloseOutlinedIcon />
        </IconButton>
      )}
    </div>
  );
})({
  display: "grid",
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  padding: "16px 32px",
  "& .MuiDialogTitle-root": {
    padding: 0,
  },
});
